
import {
  Vue, Component, Watch, Ref, Prop,
} from 'vue-property-decorator';
import {
  // eslint-disable-next-line max-len
  Dialog, Button, Divider, Row, Col, Form, FormItem, Input, Select, Option,
  Table,
  CheckboxGroup,
  Checkbox,
  TableColumn,
  RadioGroup,
  Radio,
} from 'element-ui';
import { log } from 'util';
import api from '@/api/exam';
import app from '@/api/app';
import { ITABLECOLCONF } from '@/types/base.d';
import { COMMON_DATA_TYPE } from '@/libs/config';
// import addOrModifyHead from './addOrModifyQsHead.vue';
import addOrModifyCommon from '../../../../components/common/addOrModifyCommon.vue';
import { Message } from '../../../../../../plugin/message/index';
// import { delete } from 'vue/types/umd';
@Component({
  components: {
    Dialog,
    Button,
    Divider,
    Row,
    Col,
    addOrModifyCommon,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Table,
    TableColumn,
    CheckboxGroup,
    Checkbox,
    RadioGroup,
    Radio,

  },
})
export default class addOrModify extends Vue {
  @Ref('testForm') readonly testFormView!: Form;

  @Prop()backCallback!: Function;

  @Prop({
    type: Boolean,
    default: false,
  }) isEdit!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) isAddPriew!: boolean;

  @Prop({
    type: String,
    default: false,
  }) worType!: string;

  @Prop({
    type: String,
    default: false,
  }) title!: string;

  @Prop({
    type: String,
    default: false,
  }) testId!: string;

  @Prop({
    type: String,
    default: false,
  }) worContent!: string;

  private richEditor: any = {
    dialogVisible: false,
    object: null,
    parameterName: '',
    instance: null,
  };

  private postForm: any = {
    repoIds: [],
    tagList: [],
    answerList: [],
  }

  private questionForm: any = {
    type: '',
    knowledge: '',
    name: '',
    remark: '',
    quesbank: '',
    level: '',
    serial: '',
  };

  private rules: any = {
    type: [{
      required: true,
      message: '请选择题目类型',
      trigger: 'blur',
    }],
    // knowledge: [{
    //   required: true,
    //   message: '请选择知识点',
    //   trigger: 'change',
    // }],
    level: [{
      required: true,
      message: '请选择难度等级',
      trigger: 'change',
    }],
    // quesbank: [{
    //   required: true,
    //   message: '请选择题库名称',
    //   trigger: 'change',
    // }],
    name: [{
      required: true,
      message: '请输入试题内容',
      trigger: 'change',
    }],
  };

  // private title: string = '试题添加';

  private isNeedAddOrModify = false;

  private isLoading = false;

  private loading = false;

  private quesBank = [];

  private difficultyType: any = [];

  private knowledges: any = [];

  private question: any = [];

  private trueCorret: any = [];

  // eslint-disable-next-line class-methods-use-this
  mounted() {
    if (this.isEdit) {
      this.isEditAndGetContent();
      api.checkTestQues(this.testId).then((res: any) => {
        if (res > 0) {
          this.isAble = true;
        }
      });
    }
    // 获取题库
    api.getAllQuesBank().then((res: any) => {
      // this.quesBank = res;
      this.quesBank = res.filter((item:any) => {return item.status !== 1})
    });
    app.getBaseDataByType([COMMON_DATA_TYPE.DIFFICULTY, COMMON_DATA_TYPE.KNOWLEDGE, COMMON_DATA_TYPE.QUESTION]).then((res: any) => {
      // 获取难易程度
      this.difficultyType = res.difficulty;
      // 获取知识点
      this.knowledges = res.knowledge;
      // 获取试题类型
      this.question = res.question;
    });
  }

  // 判断是否是修改。若修改则默认填入内容
  isEditAndGetContent() {
    api.getQuesDetail(this.testId).then((res: any) => {
      this.questionForm.quesbank = res.subjectId;
      this.questionForm.type = res.qstType;
      // this.questionForm.name = res.title
      this.questionForm.level = res.difficulty.toString();
      this.questionForm.remark = res.analyze;
      this.questionForm.knowledge = res.knowledge !== '' ? res.knowledge.split(',') : '';
      // this.postForm.answerList = res.options;
      this.questionForm.serial = res.serial;
      // 点击修改回显答案选项
      const Aar = res.correct.split(',');
      for (let i = 0; i < Aar.length; i++) {
        // eslint-disable-next-line no-param-reassign
        for (let j = 0; j < res.options.length; j++) {
          if (res.options[j].prefix === Aar[i]) {
            // eslint-disable-next-line no-param-reassign
            res.options[j].isRight = true;
          }
        }
      }
      this.postForm.answerList = res.options;
      // eslint-disable-next-line no-plusplus
      // for (let i = 0; i < Aar.length; i++) {
      //   // eslint-disable-next-line no-plusplus
      //   for (let j = 0; j < this.postForm.answerList.length; j++) {
      //     if (this.postForm.answerList[j].prefix === Aar[i]) {
      //       this.postForm.answerList[j].isRight = true;
      //     }
      //   }
      // }
    });
    if (this.isEdit) {
      this.questionForm.name = this.worContent;
      if (this.worType === '判断题') {
        // eslint-disable-next-line no-unused-expressions
        this.questionForm.type = '3';
        this.addAnwser();
      } else if (this.worType === '单选题') {
        // eslint-disable-next-line no-unused-expressions
        this.questionForm.type = '1';
        this.addAnwser();
      } else if (this.worType === '多选题') {
        // eslint-disable-next-line no-unused-expressions
        this.questionForm.type = '2';
        this.addAnwser();
      }
    }
  }

  // 选择框改变事件添加答案
  // eslint-disable-next-line class-methods-use-this
  addAnwser() {
    if (this.postForm.answerList.length >= 3) {
      this.isAble = true;
    }
    if (this.questionForm.type === '3') {
      this.postForm.answerList.length = 0;
      this.postForm.answerList.push({
        prefix: 'A', isRight: false, content: '', analyze: '',
      }, {
        prefix: 'B', isRight: false, content: '', analyze: '',
      }, {
        prefix: 'C', isRight: false, content: '', analyze: '',
      }, {
        prefix: 'D', isRight: false, content: '', analyze: '',
      });
    } else if (this.questionForm.type === '0') {
      this.postForm.answerList.length = 0;
      this.postForm.answerList.push({
        prefix: 'A', isRight: true, content: '正确', analyze: '',
      }, {
        prefix: 'B', isRight: false, content: '错误', analyze: '',
      });
      this.isAble = true;
    } else if (this.questionForm.type === '4') {
      this.postForm.answerList.length = 0;
      this.postForm.answerList.push({
        prefix: 'A', isRight: false, content: '', analyze: '',
      }, {
        prefix: 'B', isRight: false, content: '', analyze: '',
      }, {
        prefix: 'C', isRight: false, content: '', analyze: '',
      }, {
        prefix: 'D', isRight: false, content: '', analyze: '',
      });
    }
  }

  private correctList: any = []

  // 获取正确答案
  fitterMethod() {
    if (this.postForm.answerList.length > 0) {
      // eslint-disable-next-line array-callback-return
       this.correctList = this.postForm.answerList.filter((item: any) =>
        // eslint-disable-next-line no-unused-expressions
        // eslint-disable-next-line implicit-arrow-linebreak
        item.isRight === true);
    }
  }

  // 获取正确选项
  private trueList: any = [];

  fitterAwserMethod() {
    this.fitterMethod()
    // this.trueList = [];
    this.trueList = [...new Set(this.trueList)]
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.correctList.length; i++) {
      this.trueList.push(this.correctList[i].prefix);
    }
    this.trueList = [...new Set(this.trueList)]
    // if (this.questionForm.type === '3') {

    //   this.fitterMethod()
    //   this.trueList = [];
    // // eslint-disable-next-line no-plusplus
    //   for (let i = 0; i < this.correctList.length; i++) {
    //     this.trueList.push(this.correctList[i].prefix);
    //   }
    //   this.trueList = [...new Set(this.trueList)]
    //   console.log(this.trueList)
    // }
  }

  // 添加试题
  // eslint-disable-next-line class-methods-use-this
  // addTestQues() {
  //   this.fitterMethod();
  //   this.fitterAwserMethod();
  //   const add = {
  //     title: '',
  //     options: [
  //       {
  //         prefix: 'A',
  //         content: this.postForm.answerList[0].content,
  //         analyze: this.postForm.answerList[0].analyze,
  //       },
  //       {
  //         prefix: 'B',
  //         content: this.postForm.answerList[1].content,
  //         analyze: this.postForm.answerList[1].analyze,
  //       },
  //     ],
  //     correct: '',
  //     analyze: '',
  //     difficulty: '',
  //     subjectId: '',
  //     knowledge: '',
  //     qstType: '',
  //   };
  //   if (this.questionForm.type === '3') {
  //     // eslint-disable-next-line no-debugger
  //     add.title = this.questionForm.name;
  //     // add.options = [
  //     //   {
  //     //     prefix: 'A',
  //     //     content: this.postForm.answerList[0].content,
  //     //   },
  //     //   {
  //     //     prefix: 'B',
  //     //     content: this.postForm.answerList[1].content,
  //     //   },
  //     //   {
  //     //     prefix: 'C',
  //     //     content: this.postForm.answerList[2].content,
  //     //   },
  //     // ];
  //     for (let i = 0; i < this.postForm.answerList.length; i++) {
  //       delete this.postForm.answerList[i].isRight;
  //     }
  //     add.options = this.postForm.answerList;
  //     add.correct = this.trueList.toString();
  //     add.analyze = this.questionForm.remark;
  //     add.difficulty = this.questionForm.level;
  //     add.subjectId = this.questionForm.quesbank;
  //     add.knowledge = this.questionForm.knowledge.toString();
  //     add.qstType = '3';
  //   } else if (this.questionForm.type === '4') {
  //     add.title = this.questionForm.name;
  //     add.qstType = '4';
  //     // eslint-disable-next-line no-plusplus
  //     for (let i = 0; i < this.postForm.answerList.length; i++) {
  //       delete this.postForm.answerList[i].isRight;
  //     }
  //     add.options = this.postForm.answerList;
  //     add.correct = this.trueList.toString();
  //     add.analyze = this.questionForm.remark;
  //     add.difficulty = this.questionForm.level;
  //     add.subjectId = this.questionForm.quesbank;
  //     add.knowledge = this.questionForm.knowledge.toString();
  //   } else if (this.questionForm.type === '0') {
  //     add.title = this.questionForm.name;
  //     add.qstType = '0';
  //     // eslint-disable-next-line no-plusplus
  //     for (let i = 0; i < this.postForm.answerList.length; i++) {
  //       delete this.postForm.answerList[i].isRight;
  //     }
  //     add.options = this.postForm.answerList;
  //     add.correct = this.trueList.toString();
  //     add.analyze = this.questionForm.remark;
  //     add.difficulty = this.questionForm.level;
  //     add.subjectId = this.questionForm.quesbank;
  //     add.knowledge = this.questionForm.knowledge.toString();
  //   }
  //   api.addTestQues(add).then((res: any) => {
  //     this.back();
  //     this.isLoading = false;
  //   // eslint-disable-next-line no-return-assign
  //   }).catch(() => (this.isLoading = false));
  // }

  // 修改试题
  /* eslint-disable class-methods-use-this */
  modifyTestQues(row: any) {
    const data = {};
    api.modifyTestQues(data).then((res: any) => {
    });
  }


  back() {
    this.backCallback();
  }

  private isPriew: boolean = false;

  // 预览回调
  priewCallBack() {
    this.isPriew = true;
  }

  resetForm() {
    this.testFormView.resetFields();
    // eslint-disable-next-line no-return-assign
    Object.keys(this.questionForm).forEach(key => this.questionForm[key] = '');
    // eslint-disable-next-line no-return-assign
    Object.keys(this.postForm).forEach(key => this.postForm[key] = []);
  }

  private singleleLength: number = 0;

  private multipleLength: number = 0;

  private judgeLength: number = 0;

  private copyAnswerList: any = []

  copy (obj: any) {
        var newobj = obj.constructor === Array ? [] : {};
        if(typeof obj !== 'object'){
            return;
        }
        for(var i in obj){
           newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
           delete newobj[i].isRight
        }
        return newobj
}

  submitForm() {
    // this.fitterAwserMethods()
    // console.log(this.trueLists)
    this.testFormView.validate((isSuccess: boolean) => {
      if (isSuccess) {
        this.fitterMethod();
        this.fitterAwserMethod();
        let add = {
          title: '',
          options: [
            // {
            //   prefix: 'A',
            //   content: this.postForm.answerList[0].content,
            //   analyze: this.postForm.answerList[0].analyze,
            // },
            // {
            //   prefix: 'B',
            //   content: this.postForm.answerList[1].content,
            //   analyze: this.postForm.answerList[1].analyze,
            // },
          ],
          correct: '',
          analyze: '',
          difficulty: '',
          subjectId: '',
          knowledge: '',
          qstType: '',
          serial: '',
          id: this.testId,
        };
        if (this.questionForm.type === '3') {
          // eslint-disable-next-line no-debugger
          add.title = this.questionForm.name;
          // add.options = [
          //   {
          //     prefix: 'A',
          //     content: this.postForm.answerList[0].content,
          //     analyze: this.postForm.answerList[0].analyze,
          //   },
          //   {
          //     prefix: 'B',
          //     content: this.postForm.answerList[1].content,
          //     analyze: this.postForm.answerList[1].analyze,
          //   },
          //   {
          //     prefix: 'C',
          //     content: this.postForm.answerList[2].content,
          //     analyze: this.postForm.answerList[2].analyze,
          //   },
          //   {
          //     prefix: 'D',
          //     content: this.postForm.answerList[3].content,
          //     analyze: this.postForm.answerList[3].analyze,
          //   },
          // ];
          // for (let i = 0; i < this.postForm.answerList.length; i++) {
          //   this.copyAnswerList = [...this.postForm.answerList]
          //   delete this.copyAnswerList[i].isRight;

          // }
          // for (let i = 0; i < this.copyAnswerList.length; i++) {
          //   this.copyAnswerList = [...this.postForm.answerList]
          //   delete this.copyAnswerList[i].isRight;
          // }
          this.copyAnswerList = this.copy(this.postForm.answerList)
          add.options = this.copyAnswerList;
          // add.correct = this.trueList.toString();
          this.singleleLength = this.correctList.length;
          if (this.correctList.length > 0) {
            add.correct = this.correctList[0].prefix;
          }
          // add.correct = this.correctList[0].prefix;
          // this.singleleLength = this.correctList.length
          add.analyze = this.questionForm.remark;
          add.difficulty = this.questionForm.level;
          add.subjectId = this.questionForm.quesbank;
          add.knowledge = this.questionForm.knowledge.toString();
          add.qstType = '3';
          add.serial = this.questionForm.serial;
        } else if (this.questionForm.type === '4') {
          add.title = this.questionForm.name;
          add.qstType = '4';
          // add.options = [
          //   {
          //     prefix: 'A',
          //     content: this.postForm.answerList[0].content,
          //     analyze: this.postForm.answerList[0].analyze,
          //   },
          //   {
          //     prefix: 'B',
          //     content: this.postForm.answerList[1].content,
          //     analyze: this.postForm.answerList[1].analyze,
          //   },
          //   {
          //     prefix: 'C',
          //     content: this.postForm.answerList[2].content,
          //     analyze: this.postForm.answerList[2].analyze,
          //   },
          //   {
          //     prefix: 'D',
          //     content: this.postForm.answerList[3].content,
          //     analyze: this.postForm.answerList[3].analyze,
          //   },
          // ];
          for (let i = 0; i < this.postForm.answerList.length; i++) {
            this.copyAnswerList = [...this.postForm.answerList]
            delete this.copyAnswerList[i].isRight;
          }
          add.options = this.copyAnswerList;
          add.correct = this.trueList.toString();
          this.multipleLength = this.trueList.length;
          add.analyze = this.questionForm.remark;
          add.difficulty = this.questionForm.level;
          add.subjectId = this.questionForm.quesbank;
          add.knowledge = this.questionForm.knowledge.toString();
        } else if (this.questionForm.type === '0') {
          add.title = this.questionForm.name;
          add.qstType = '0';
          add.serial = this.questionForm.serial;
          // add.options = [
          //   {
          //     prefix: 'F',
          //     content: this.postForm.answerList[1].content,
          //     analyze: this.postForm.answerList[1].analyze,
          //   },
          //   {
          //     prefix: 'T',
          //     content: this.postForm.answerList[0].content,
          //     analyze: this.postForm.answerList[0].analyze,
          //   },
          // ];
          for (let i = 0; i < this.postForm.answerList.length; i++) {
            this.copyAnswerList = [...this.postForm.answerList]
            delete this.copyAnswerList[i].isRight;
          }
          add.options = this.copyAnswerList;
          add.correct = this.trueList.toString();
          this.judgeLength = this.trueList.length;
          add.analyze = this.questionForm.remark;
          add.difficulty = this.questionForm.level;
          add.subjectId = this.questionForm.quesbank;
          add.knowledge = this.questionForm.knowledge.toString();
          add.serial = this.questionForm.serial;
        }
        if (this.isEdit) {
          this.isLoading = true;
          // eslint-disable-next-line no-debugger
          if (this.singleleLength === 1 || this.multipleLength >= 2 || this.judgeLength === 1) {
            this.loading = false;
            api.modifyTestQues(add).then((res: any) => {
              this.back();
              this.isLoading = false;
              this.loading = false;
              // eslint-disable-next-line no-return-assign
            }).catch(() => (this.loading = false));
          } else {
            Message.error('请选择正确格式的选项');
          }
          // api.modifyTestQues(add).then((res: any) => {
          //   this.back();
          //   this.isLoading = false;
          //   // eslint-disable-next-line no-return-assign
          // }).catch(() => (this.isLoading = false));
        } else {
          this.isLoading = true;
          // this.addTestQues();
          // this.fitterAwserMethod()
          // this.trueList = [...new Set(this.trueList)]
          console.log(this.singleleLength)
          if (this.singleleLength === 1 || this.multipleLength >= 2 || this.judgeLength === 1) {
            this.loading = false;
            add.id = '';
            api.addTestQues(add).then((res: any) => {
              this.back();
              this.isLoading = false;
              this.loading = false;
              // eslint-disable-next-line no-return-assign
            }).catch(() => (this.loading = false));
          } else {
            Message.error('请选择正确格式的选项');
          }
          // api.addTestQues(add).then((res: any) => {
          //   this.back();
          //   this.isLoading = false;
          //   // eslint-disable-next-line no-return-assign
          // }).catch(() => (this.isLoading = false));
          // this.correctList = [];
        }
      }
    });
  }

  private inputContent: string = ''

  inputClick(object: any, parameterName:string) {
    this.inputContent = object[parameterName];
    this.richEditor.object = object;
    this.richEditor.parameterName = parameterName;
    this.richEditor.dialogVisible = true;
  }

  editorReady(instance: any) {
    this.richEditor.instance = instance;
    const currentContent = this.richEditor.object[this.richEditor.parameterName];
    this.richEditor.instance.setContent(currentContent);
    // 光标定位到Ueditor
    // this.richEditor.instance.focus(true);
  }

  showOrCloseAdd() {
    this.richEditor.dialogVisible = true;
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  editorConfirm() {
    const content = this.richEditor.instance.getContent();
    this.richEditor.object[this.richEditor.parameterName] = content;
    this.richEditor.dialogVisible = false;
  }
  // 添加答案
  // 按钮是否禁用

  private isAble: boolean = false;

  private answerList: any = [];

  private answerIndex = {'A': 0, 'B': 1, 'C': 2, 'D': 3};

  // eslint-disable-next-line class-methods-use-this
  handleAddAnswer() {
    if (this.postForm.answerList.length > 3) {
      this.isAble = true;
    } else {
      if (this.removeItemList.length === 0) {
        return;
      }
      this.removeItemList.sort();
      this.postForm.answerList.splice(this.answerIndex[this.removeItemList[0]], 0, {
        prefix: this.removeItemList[0], isRight: false, content: '', analyze: '',
      });
      this.removeItemList.shift();
    }
  }

  private removeItemList: any = [];

  // 删除答案
  // eslint-disable-next-line class-methods-use-this
  removeItem(row: any, index:number) {
    this.removeItemList.push(row.prefix)
    this.postForm.answerList.splice(index, 1);
    if (this.postForm.answerList.length < 4) {
      this.isAble = false
    }
    // this.foreachList()
    for (let i = 0; i < this.postForm.answerList.length; i++) {
      // this.answerList = []
      this.answerList.push(this.postForm.answerList[i].prefix)
    }
    this.removeItemList = [...new Set(this.removeItemList)]
  }

  getData(params?: any) {
    this.loading = true;
    // this.page.params = params;
    // const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    // api.getCList(data).then((res: any) => {
    //   this.cList = res.content;
    //   this.total = res.totalElements;
    //   this.loading = false;
    // });
    setTimeout(() => {
      const dataArray: Array<any> = Array.of();
      // this.cList = dataArray;
      // this.total = dataArray.length;
      this.loading = false;
    }, 2000);
  }
}

